import React from "react";

interface ContentProps {
  children: React.ReactNode;
}

const Content: React.FC<ContentProps> = ({ children }) => {
  return <div className="max-w-lg mx-auto">{children}</div>;
};

export default Content;
